import { Skeleton } from "primereact/skeleton"
import { ReactElement } from "react"
import {LoadingGraphProps} from "../../types/LoadingGraphProps";

export const LoadingGraph = (props: LoadingGraphProps): ReactElement => {
    return (
        <Skeleton shape="circle" width="100%" height="60vh" hidden={props.hidden} className="mr-2"></Skeleton>
    )
}